'use client';

import { useContentSize } from '@/components/SizeProvider';
import { getChromeBarHeight } from '@/lib/utils/desktopGeometry';

const LINE_WIDTH_RATIO = 0.465;

export default function FooterDesktop() {
  const { width: widthContent, height: heightContent } = useContentSize();
  const lineWidth = `${widthContent * LINE_WIDTH_RATIO}px`;

  return (
    <footer
      className='footer-desktop-container'
      style={{
        height: getChromeBarHeight(heightContent),
      }}
    >
      <div className="footer-info-container"
        style={{
          width: widthContent,
        }}>
        <div className={'footer-info-copyright'}>
          <p className="text-footer">CONCOCTING CHAOS</p>
          <p className="text-footer">TRUST THE PROCESS</p>
        </div>
        <div className="line-footer"
          style={{
            width: lineWidth
          }} 
        />
        <div className={'floating-man-parent'}>
          <img 
            src="/assets/gif/FLOATINGMAN.webp" 
            alt="Floating Man" 
            width={1000}
            height={1000}
            style={{ width: '52%', height: 'auto' }}
          />
        </div>
        <div className="line-footer"
          style={{
            width: lineWidth
          }} 
        />
      </div>
    </footer>
  )
}
